import {z} from 'zod'
import {validateState} from '../ValidateState.ts'
import {TileHexType} from './TileHexState.ts'

export const fogTileDiceNumber: number = 0

export const fogTileGroupStateSchema = z
    .object({
        fogTileIndexes: z.array(z.number().int().min(0)),
        possibleTileTypes: z.array(z.enum(TileHexType)),
        possibleDiceNumbers: z.array(z.number().int().min(2).max(12)),
    })
    .strict()

export type FogTileGroupState = z.infer<typeof fogTileGroupStateSchema>

export function validateFogTileGroupState(data: unknown) {
    return validateState(fogTileGroupStateSchema, data)
}

export const fogTileGroupStatePartialSchema = fogTileGroupStateSchema.partial().refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one property must be provided',
})

export type FogTileGroupStatePartial = z.infer<typeof fogTileGroupStatePartialSchema>

export function validateFogTileGroupStatePartial(data: unknown) {
    return validateState(fogTileGroupStatePartialSchema, data)
}
